import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";

export interface ILoginFormSchema {
  phoneNumber: string;
  password: string;
}

export const loginFormInitialValues: ILoginFormSchema = {
  phoneNumber: "",
  password: "",
};

export const loginFormValidationSchema = z.object<
  IShapeOfField<ILoginFormSchema>
>({
  phoneNumber: z.string().min(1),
  password: z.string(),
});
